import request from '@/utils/request'
const baseUrl = '/order'
/**
 * 作品的购物车
 */
export function getWorksShoppingCartList(pageIndex = 1, pageSize = 100) {
  return request({
    url: `/works/private/rest/shoppingCart/list`,
    method: 'POST',
    data: {
      pageIndex: pageIndex,
      pageSize: pageSize
    }
  })
}

/**
 * 学院教程的购物车
 */
export function getCollegeShoppingCartList(pageIndex = 1, pageSize = 100) {
  return request({
    url: `/college/private/rest/shoppingCart/list`,
    method: 'POST',
    data: {
      pageIndex: pageIndex,
      pageSize: pageSize
    }
  })
}

/**
 * 素材购物车列表
 */
export function getShoppingCartList(data) {
  return request({
    url: `/material/private/rest/shoppingCart/list`,
    method: 'POST',
    data: {
      pageIndex: 1,
      pageSize: 100
    }
  })
}

/**
 * 学院教程的购物车
 */
export function getOrderShoppingCartList() {
  return request({
    url: `${baseUrl}/private/rest/member/shoppingCart/get`,
    method: 'GET',
  })
}

/**
 * 学院教程删除
 */
export function collegeShopDelete(id) {
  return request({
    url: `/college/private/rest/shoppingCart/delete/${id}`,
    method: 'POST',
  })
}

/**
 * 作品删除
 */
export function worksShopDelete(id) {
  return request({
    url: `/works/private/rest/shoppingCart/delete/${id}`,
    method: 'POST',
  })
}

/**
 * 素材删除
 */
export function materialShopDelete(id) {
  return request({
    url: `/material/private/rest/shoppingCart/delete/${id}`,
    method: 'POST',
  })
}

/**
 * 会员删除
 */
export function memberDelete() {
  return request({
    url: `${baseUrl}/private/rest/member/shoppingCart/delete`,
    method: 'GET',
  })
}

/**
 * 学院教程的购物车
 */
export function createPay(data) {
  return request({
    url: `${baseUrl}/private/rest/create`,
    method: 'POST',
    data
  })
}

/**
 * 获取订单中心列表
 */
export function getOrderList(data) {
  return request({
    url: `${baseUrl}/private/rest/list`,
    method: 'POST',
    data
  })
}

/**
 * 继续支付
 */
export function payAgain(id) {
  return request({
    url: `${baseUrl}/private/rest/pay/${id}`,
    method: 'POST',
    data: {
      isMobile: false
    }
  })
}

/**
 * 收入列表
 */
export function getIncomeList(data) {
  return request({
    url: `${baseUrl}/private/rest/income/list`,
    method: 'POST',
    data
  })
}

/**
 * 支出列表
 */
export function getExpenseList(data) {
  return request({
    url: `${baseUrl}/private/rest/expense/list`,
    method: 'POST',
    data
  })
}

/**
 * 捐赠
 */
export function acceptDonations(data) {
  return request({
    url: `${baseUrl}/private/rest/acceptDonations`,
    method: 'POST',
    data
  })
}